import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex-grow flex overflow-hidden" }
const _hoisted_2 = { class: "flex-grow flex flex-col h-full relative" }
const _hoisted_3 = {
  key: 0,
  class: "min-h-300 absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Loading virtual mailbox...", -1)
const _hoisted_5 = {
  key: 0,
  class: "min-h-300 absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Loading virtual mailbox", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("header", { class: "p-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ")
], -1)
const _hoisted_8 = { class: "flex flex-col pt-4 items-center justify-center relative w-full" }
const _hoisted_9 = { class: "rounded-md bg-white shadow-lg px-5 py-8 w-2/4 flex flex-col gap-4" }
const _hoisted_10 = { class: "flex gap-4 items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Setup a virtual mailbox for all your mail, digitized. Have all your mail scanned and searchable in yout Thatch inbox, as well as delivered to your email. Remove paper headaches from your life ", -1)
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("header", { class: "p-4" }, " Virtual Mailbox ", -1)
const _hoisted_15 = { class: "flex flex-col pt-4 items-center justify-center relative" }
const _hoisted_16 = { class: "rounded-md bg-white shadow-lg px-5 py-8 w-3/4 2xl:w-2/4 flex flex-col gap-4" }
const _hoisted_17 = { class: "flex gap-4 items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " Setup a virtual mailbox for all your mail, digitized. Have all your mail scanned and searchable in yout Thatch inbox, as well as delivered to your email. Remove paper headaches from your life ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " Choose your location ", -1)
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "py-4 flex flex-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, " Virtual Mailbox ")
], -1)
const _hoisted_25 = { class: "flex justify-between pl-4 pr-8 items-end" }
const _hoisted_26 = { class: "flex gap-4 text-sm" }
const _hoisted_27 = { class: "flex gap-5 items-center" }
const _hoisted_28 = {
  key: 1,
  class: "text-sm flex items-center"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 1,
  class: "h-4 w-4 ml-2"
}
const _hoisted_31 = { class: "flex gap-4 justify-between items-center" }
const _hoisted_32 = { class: "flex gap-2" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "border-l border-gray-400 text-xs w-32 pl-2" }
const _hoisted_35 = {
  key: 3,
  class: "flex gap-2"
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "border-l border-gray-400 text-xs w-32 pl-2" }
const _hoisted_38 = {
  key: 1,
  class: "font-medium text-center w-full text-lg"
}
const _hoisted_39 = {
  key: 1,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-2"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, " Loading messages...", -1)
const _hoisted_41 = {
  key: 2,
  class: "pl-3 text-sm fixed justify-center mt-2 flex bottom-0 w-full left-0 right-0 bg-blue-100 py-2"
}
const _hoisted_42 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-2"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, " Loading Shipments...", -1)
const _hoisted_44 = {
  key: 1,
  class: "m-auto flex flex-col items-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl mb-2" }, " You have no shipments. ", -1)
const _hoisted_46 = {
  key: 2,
  class: "flex flex-col gap-2 w-full"
}
const _hoisted_47 = { class: "ml-2" }
const _hoisted_48 = { class: "grid lg:grid-cols-4 grid-cols-2" }
const _hoisted_49 = { class: "flex items-center justify-between border-0 border-b pb-1 border-solid border-gray-200" }
const _hoisted_50 = { class: "whitespace-nowrap" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "border border-solid border-gray-200 mt-auto" }, null, -1)
const _hoisted_52 = {
  key: 1,
  class: "text-center my-12"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " Your virtual mailbox system subscription is inactive ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, " Go to current subscription to get more details ", -1)
const _hoisted_55 = {
  key: 1,
  class: "text-center my-12"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " You have no virtual mailbox system subscription ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, " To start using virtual mailbox system purchase the subscription ", -1)

import {
	DropdownWithTooltip,
	SvgIcon,
	UiButton,
	UiLoader,
	BorderedButton,
	UiLine
} from '@/ui-kit';
import { useToggle } from '@vueuse/shared';
import { reactive, ref, computed, watch } from 'vue';
import {
	VirtualMailFilter,
	useVirtualMailbox
} from '../use-virtual-mailbox';
import MailPreview from '../components/MailPreview.vue';
import { useRoute, useRouter } from 'vue-router';
import { useVirtualMailboxSystem } from '@/billing/use-virtual-mailbox-system';
import {
	VirtualMailboxShipment,
	useVirtualMailboxShipments
} from '../use-virtual-mailbox-shipments';
import AddShipmentDialog from '../components/AddShipmentDialog.vue';
import { useVirtualMailboxAddresses } from '../use-virtual-mailbox-addresses';
import AttachedMailsDialog from '../components/AttachedMailsDialog.vue';
import { useBilling } from '@/billing';
import { Mailbox } from '../mailbox';
import { useCompanyProfile } from '@/account';
import { ElInfiniteScroll as vInfiniteScroll } from 'element-plus/lib';
import UploadMailDialog from '../components/UploadMailDialog.vue';

type ActiveTab = VirtualMailFilter | 'shipping';

export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualMailboxInbox',
  setup(__props) {

const {
	isLoading,
	isEnabled,
	locations,
	items,
	loadMails,
	mails,
	deleteNow,
	hasMoreMails,
	loadNextMails,
	activeFilter
} = useVirtualMailbox();
const {
	isLoading: isShipmentsLoading,
	shipments,
	loadShipments,
	finishShipment
} = useVirtualMailboxShipments();
const { toAddressString } = useVirtualMailboxAddresses();
const { getProductSettings } = useBilling();
const { isPaidAccount, canUploadMail } =
	useCompanyProfile();

function isCurrentUsagePlanLimitReached(
	item?: Mailbox
): boolean {
	if (!item) {
		return false;
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return currentUsage >= productUsage;
}

function getItemUsage(item?: Mailbox): string {
	if (!item) {
		return '';
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return `<span class="${
		isCurrentUsagePlanLimitReached(item)
			? 'text-red-400'
			: ''
	} ">
		${currentUsage} </span> / ${productUsage} `;
}

const finishingIds = reactive<Set<number>>(new Set());

const route = useRoute();

const selected = ref(0);
const activeTab = ref<ActiveTab>(
	typeof route.query.activeTab === 'string'
		? (route.query.activeTab as VirtualMailFilter)
		: 'inbox'
);

const addShipmentDialogRef =
	ref<InstanceType<typeof AddShipmentDialog>>();
const attachedMailsDialogRef =
	ref<InstanceType<typeof AttachedMailsDialog>>();
const uploadMailDialogRef =
	ref<InstanceType<typeof UploadMailDialog>>();

const [loadingMessages, setLoadingMessages] = useToggle();

const options = computed(() =>
	items.value.map((item) => ({
		value: item.id,
		title: `${item.friendly_name} <br /> ${item.assigned_box_number}`
	}))
);

function initAddressId() {
	if (typeof route.params.addressId !== 'string') {
		return 0;
	}

	const addressId = parseInt(route.params.addressId);

	if (Number.isNaN(addressId)) {
		return 0;
	}

	return addressId;
}

const addressId = ref(initAddressId());

watch(
	items,
	async () => {
		if (items.value[0] && addressId.value === 0) {
			addressId.value = items.value[0].id;
			setLoadingMessages(true);
			await Promise.all([
				activeTab.value === 'shipping'
					? Promise.resolve()
					: loadMails(
							items.value[0].id,
							activeTab.value
					  ),
				loadShipments(items.value[0].id)
			]);
			setLoadingMessages(false);
		}
	},
	{ immediate: true }
);

const selectedAddress = computed(() => {
	return options.value.find(
		(item) => item.value === addressId.value
	)?.title;
});

const selectedMailbox = computed(() => {
	return items.value.find(
		(item) => item.id === addressId.value
	);
});

async function fetchItems(id: number) {
	addressId.value = id;
	router.replace({ query: { addressId: id.toString() } });
	setLoadingMessages(true);
	await Promise.all([loadMails(id), loadShipments(id)]);
	setLoadingMessages(false);
}

const { hasVirtualMailboxSystem, isVirtualMailboxActive } =
	useVirtualMailboxSystem();

const router = useRouter();

function toPurchase() {
	return router.push({ name: 'AvailablePlans' });
}

function toSubscription() {
	return router.push({ name: 'CurrentSubscription' });
}

function addShipment() {
	addShipmentDialogRef.value?.openDialog();
}

async function finish(item: VirtualMailboxShipment) {
	finishingIds.add(item.id);
	await finishShipment(addressId.value, item.id);
	finishingIds.delete(item.id);
}

function getLocation(item?: Mailbox): string {
	if (!item) {
		return '';
	}

	return `${item.physical_location.line}, ${item.physical_location.city} ${item.physical_location.state} ${item.physical_location.zip}`;
}

const { isLoaded } = useBilling();

const isHovered = ref(false);
const [moreLoading, setMoreLoading] = useToggle();

async function loadMore() {
	if (
		!isLoaded.value ||
		moreLoading.value ||
		!hasMoreMails.value ||
		loadingMessages.value
	) {
		return;
	}
	setMoreLoading(true);
	await loadNextMails();
	setMoreLoading(false);
}

async function changeMailsTab(tabFilter: ActiveTab) {
	if (activeTab.value === tabFilter) {
		return;
	}

	activeTab.value = tabFilter;
	await router.replace({
		query: {
			activeTab: tabFilter,
			addressId: route.query.addressId
		}
	});

	if (tabFilter === 'shipping') {
		return;
	}

	setLoadingMessages(true);
	await loadMails(items.value[0].id, tabFilter);
	setLoadingMessages(false);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isLoaded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(UiLoader))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(hasVirtualMailboxSystem))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(isVirtualMailboxActive))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(isLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _hoisted_6,
                              _createVNode(_unref(UiLoader))
                            ]))
                          : (!_unref(isEnabled))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_7,
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_unref(SvgIcon), {
                                        class: "h-10 w-10",
                                        name: "VirtualMailboxIcon"
                                      }),
                                      _hoisted_11
                                    ]),
                                    _hoisted_12,
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_RouterLink, { to: {
												name: 'VirtualMailbox'
											} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(UiButton), { class: "!rounded-none" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Let's get started ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ], 64))
                            : (!_unref(items).length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_14,
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_unref(SvgIcon), {
                                          class: "h-10 w-10",
                                          name: "VirtualMailboxIcon"
                                        }),
                                        _hoisted_18
                                      ]),
                                      _hoisted_19,
                                      _hoisted_20,
                                      _createElementVNode("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locations), (location) => {
                                          return (_openBlock(), _createBlock(_unref(UiButton), {
                                            theme: 
												selected.value ===
												location.id
													? 'dark'
													: 'dark-outlined'
											,
                                            class: _normalizeClass([
												'!rounded-none',
												{
													'opacity-50':
														selected.value !==
														location.id
												}
											]),
                                            onClick: ($event: any) => (
												selected.value =
													location.id
											),
                                            key: 
												location.id
											
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(location.city) + ", " + _toDisplayString(location.state), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["theme", "class", "onClick"]))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_RouterLink, {
                                          to: {
												name: 'AddVirtualMailbox',
												params: selected.value
													? {
															location:
																selected.value
													  }
													: {}
											}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(UiButton), {
                                              class: "!rounded-none",
                                              disabled: 
													!selected.value
												
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Add first virtual mailbox ")
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        }, 8, ["to"])
                                      ])
                                    ])
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("header", _hoisted_23, [
                                    _hoisted_24,
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("button", {
                                          class: "cursor-pointer flex items-center gap-2 relative",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
												changeMailsTab(
													'inbox'
												)
											))
                                        }, [
                                          _createTextVNode(" Inbox "),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["h-px transition absolute -bottom-2.5 -left-1 -right-1", 
													activeTab.value ===
													'inbox'
														? 'bg-dark-blue-400'
														: 'bg-transparent'
												])
                                          }, null, 2)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "cursor-pointer flex items-center gap-2 relative",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (
												changeMailsTab(
													'shipping'
												)
											))
                                        }, [
                                          _createTextVNode(" Shipping "),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["h-px transition absolute -bottom-2.5 -left-1 -right-1", 
													activeTab.value ===
													'shipping'
														? 'bg-dark-blue-400'
														: 'bg-transparent'
												])
                                          }, null, 2)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "cursor-pointer flex items-center gap-2 relative",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (
												changeMailsTab(
													'archived'
												)
											))
                                        }, [
                                          _createTextVNode(" Archive "),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["h-px transition absolute -bottom-2.5 -left-1 -right-1", 
													activeTab.value ===
													'archived'
														? 'bg-dark-blue-400'
														: 'bg-transparent'
												])
                                          }, null, 2)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "cursor-pointer flex items-center gap-2 relative",
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (
												changeMailsTab(
													'trash'
												)
											))
                                        }, [
                                          _createTextVNode(" Trash "),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["h-px transition absolute -bottom-2.5 -left-1 -right-1", 
													activeTab.value ===
													'trash'
														? 'bg-dark-blue-400'
														: 'bg-transparent'
												])
                                          }, null, 2)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_27, [
                                        (
												_unref(canUploadMail)
											)
                                          ? (_openBlock(), _createBlock(_unref(UiButton), {
                                              key: 0,
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (
												uploadMailDialogRef.value?.openDialog()
											)),
                                              class: "!text-sm !h-10 !px-2",
                                              theme: "primary-outlined"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(SvgIcon), {
                                                  class: "h-5 w-5 mr-2",
                                                  name: "only-plus"
                                                }),
                                                _createTextVNode("Upload mail ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
												_unref(isPaidAccount)
											)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                              _createTextVNode(" Current usage: "),
                                              _createElementVNode("span", {
                                                innerHTML: 
													getItemUsage(
														_unref(selectedMailbox)
													)
												
                                              }, null, 8, _hoisted_29),
                                              (
													isCurrentUsagePlanLimitReached(
														_unref(selectedMailbox)
													)
												)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "group relative",
                                                    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (
													isHovered.value = true
												)),
                                                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (
													isHovered.value = false
												))
                                                  }, [
                                                    _createVNode(_unref(SvgIcon), {
                                                      class: "h-4 w-4 ml-2",
                                                      name: "info"
                                                    }),
                                                    _createElementVNode("button", {
                                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (
														_ctx.$router.push(
															{
																name: 'CurrentSubscription'
															}
														)
													)),
                                                      class: _normalizeClass(["transition absolute -bottom-5 opacity-0 text-xs w-68 items-center underline cursor-pointer bg-white shadow-md py-1 px-2 -translate-x-1/2 transform group-hover:opacity-100", 
														isHovered.value
															? 'z-10'
															: '-z-1'
													])
                                                    }, " Save funds by purchasing bigger volume plan ", 2)
                                                  ], 32))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_30))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
												_unref(options).length >
												1
											)
                                          ? (_openBlock(), _createBlock(_unref(DropdownWithTooltip), {
                                              key: 2,
                                              withCheck: "",
                                              dropdownPlacement: "bottom-start",
                                              tooltipTitle: "Select address",
                                              tooltipPlacement: "bottom",
                                              modelValue: 
												addressId.value
											,
                                              "onUpdate:modelValue": 
												fetchItems
											,
                                              actions: 
												_unref(options)
											
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(BorderedButton), {
                                                  id: "from",
                                                  class: "min-w-24 text-left pl-2 !h-auto"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_31, [
                                                      _createElementVNode("div", _hoisted_32, [
                                                        _createElementVNode("span", {
                                                          class: "text-xs transition flex items-center justify-between gap-1 cursor-pointer rounded-md overflow-hidden outline-none",
                                                          innerHTML: 
																_unref(selectedAddress)
															
                                                        }, null, 8, _hoisted_33),
                                                        _createElementVNode("div", _hoisted_34, _toDisplayString(getLocation(
																	_unref(selectedMailbox)
																)), 1)
                                                      ]),
                                                      _createVNode(_unref(SvgIcon), {
                                                        name: "arrow",
                                                        class: "transform rotate-90 h-4 w-4"
                                                      })
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "onUpdate:modelValue", "actions"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createElementVNode("span", {
                                                class: "text-xs transition flex items-center justify-between gap-1 cursor-pointer rounded-md overflow-hidden outline-none",
                                                innerHTML: 
													_unref(selectedAddress)
												
                                              }, null, 8, _hoisted_36),
                                              _createElementVNode("div", _hoisted_37, _toDisplayString(getLocation(
														_unref(selectedMailbox)
													)), 1)
                                            ]))
                                      ])
                                    ]),
                                    _createVNode(_unref(UiLine), { class: "mt-2" })
                                  ]),
                                  (
									activeTab.value !== 'shipping'
								)
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["relative xl:gap-8 gap-4 p-4 min-h-350 overflow-auto scrollbar", 
									_unref(mails).length
										? 'grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 grid-cols-2'
										: 'flex items-center'
								]),
                                        "infinite-scroll-distance": 
									40
								
                                      }, [
                                        (!_unref(loadingMessages))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_unref(mails).length)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(mails), (mail) => {
                                                    return (_openBlock(), _createBlock(_component_RouterLink, {
                                                      key: mail.id,
                                                      to: {
												name: 'VirtualMailboxDetails',
												params: {
													id: mail.id,
													boxId: addressId.value
												}
											}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(), _createBlock(MailPreview, {
                                                          key: 
													mail.id
												,
                                                          mail: mail,
                                                          selectedMailbox: 
													_unref(selectedMailbox)
												
                                                        }, null, 8, ["mail", "selectedMailbox"]))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to"]))
                                                  }), 128))
                                                : (_openBlock(), _createElementBlock("h1", _hoisted_38, " No virtual mails "))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                              _hoisted_40,
                                              _createVNode(_unref(UiLoader))
                                            ])),
                                        (_unref(moreLoading))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                              _createTextVNode(" Loading more messages "),
                                              _createVNode(_unref(UiLoader), { class: "ml-2" })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 2)), [
                                        [_unref(vInfiniteScroll), loadMore]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (
										_unref(isShipmentsLoading)
									)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              _hoisted_43,
                                              _createVNode(_unref(UiLoader))
                                            ]))
                                          : (
										!_unref(shipments).length
									)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                _hoisted_45,
                                                _createElementVNode("div", null, [
                                                  _createVNode(_unref(UiButton), {
                                                    onClick: 
												addShipment
											,
                                                    class: "!text-sm !h-10 !px-2",
                                                    theme: "transparent"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(SvgIcon), {
                                                        class: "h-5 w-5 mr-2",
                                                        name: "only-plus"
                                                      }),
                                                      _createTextVNode("Add shipment ")
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"])
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, [
                                                  _createVNode(_unref(UiButton), {
                                                    onClick: 
												addShipment
											,
                                                    class: "!text-sm !h-10 !px-2",
                                                    theme: "transparent"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(SvgIcon), {
                                                        class: "h-5 w-5 mr-2",
                                                        name: "only-plus"
                                                      }),
                                                      _createTextVNode("Add shipment ")
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"])
                                                ]),
                                                _createElementVNode("div", _hoisted_48, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shipments), (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "flex gap-2 flex-col text-sm mx-2 py-2 px-4 border border-solid border-gray-200 rounded-md",
                                                      key: item.id
                                                    }, [
                                                      _createElementVNode("div", _hoisted_49, [
                                                        _createElementVNode("span", _hoisted_50, "Shipment " + _toDisplayString(item.id), 1),
                                                        _createVNode(_unref(UiButton), {
                                                          loading: 
														finishingIds.has(
															item.id
														)
													,
                                                          onClick: ($event: any) => (
														finish(
															item
														)
													),
                                                          class: _normalizeClass([
														'!text-sm !h-10 !px-2',
														{
															'opacity-0 -z-1':
																item.status !==
																	'initiated' ||
																!item.pieces_count
														}
													]),
                                                          disabled: 
														item.status !==
															'initiated' ||
														!item.pieces_count
													,
                                                          theme: "transparent"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(SvgIcon), {
                                                              class: "h-5 w-5 mr-2",
                                                              name: "only-check"
                                                            }),
                                                            _createTextVNode("Finish shipment ")
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["loading", "onClick", "class", "disabled"])
                                                      ]),
                                                      _createElementVNode("span", null, " Status: " + _toDisplayString(item.status), 1),
                                                      _createElementVNode("span", null, " To: " + _toDisplayString(_unref(toAddressString)(
														item.address
													)), 1),
                                                      _createElementVNode("span", null, " Attached mails: " + _toDisplayString(item.pieces_count
														? item.pieces_count
														: `No mails
												attached`), 1),
                                                      _hoisted_51,
                                                      _createVNode(_unref(UiButton), {
                                                        onClick: ($event: any) => (
													attachedMailsDialogRef.value?.openDialog(
														item
													)
												),
                                                        class: _normalizeClass([
													'!text-sm !h-10 !px-2',
													{
														'opacity-0 -z-1':
															item.status !==
															'initiated'
													}
												]),
                                                        theme: "transparent",
                                                        disabled: 
													item.status !==
														'initiated' ||
													finishingIds.has(
														item.id
													)
												
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(SvgIcon), {
                                                            class: "h-5 w-5 mr-2",
                                                            name: "settings"
                                                          }),
                                                          _createTextVNode("Manage Attached Mails ")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick", "class", "disabled"])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]))
                                      ], 64))
                                ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _hoisted_54,
                        _createVNode(_unref(UiButton), {
                          theme: "primary-outlined",
                          onClick: toSubscription,
                          class: "mt-6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SvgIcon), {
                              class: "mr-2 h-5 w-5",
                              name: "external-link"
                            }),
                            _createTextVNode(" To Subscription ")
                          ]),
                          _: 1
                        })
                      ]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _hoisted_56,
                  _hoisted_57,
                  _createVNode(_unref(UiButton), {
                    theme: "primary-outlined",
                    onClick: toPurchase,
                    class: "mt-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SvgIcon), {
                        class: "mr-2 h-5 w-5",
                        name: "external-link"
                      }),
                      _createTextVNode(" To Purchase ")
                    ]),
                    _: 1
                  })
                ]))
          ], 64))
    ]),
    _createVNode(AddShipmentDialog, {
      ref_key: "addShipmentDialogRef",
      ref: addShipmentDialogRef,
      mailboxId: addressId.value
    }, null, 8, ["mailboxId"]),
    (_unref(selectedMailbox))
      ? (_openBlock(), _createBlock(AttachedMailsDialog, {
          key: 0,
          mailbox: _unref(selectedMailbox),
          mails: _unref(mails),
          "mailbox-id": addressId.value,
          ref_key: "attachedMailsDialogRef",
          ref: attachedMailsDialogRef
        }, null, 8, ["mailbox", "mails", "mailbox-id"]))
      : _createCommentVNode("", true),
    (_unref(selectedMailbox) && _unref(canUploadMail))
      ? (_openBlock(), _createBlock(UploadMailDialog, {
          key: 1,
          mailboxId: _unref(selectedMailbox).id,
          ref_key: "uploadMailDialogRef",
          ref: uploadMailDialogRef
        }, null, 8, ["mailboxId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})